import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const ResourcesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // State for filters
  const [resourceType, setResourceType] = useState("all");
  const [subjectFilter, setSubjectFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [currentTab, setCurrentTab] = useState("study-materials");

  // Mock data for study materials
  const studyMaterials = [
    {
      id: 1,
      title: "Nagaland History Comprehensive Notes",
      description:
        "Complete notes covering pre-colonial, colonial, and post-independence history of Nagaland with special focus on NPSC-relevant topics.",
      type: "notes",
      format: "PDF",
      subject: "History",
      pages: 145,
      size: "4.2 MB",
      lastUpdated: "February 15, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0Y8yIkHyLMJtJDtLPYw_PaeWnfw8hgA_kCQ&s",
      downloadLink: "/downloads/nagaland-history-notes.pdf",
      premium: true,
      popular: true,
    },
    {
      id: 2,
      title: "Nagaland Polity & Governance Framework",
      description:
        "Detailed study material on Nagaland's governance structure, constitutional provisions, and administrative framework.",
      type: "notes",
      format: "PDF",
      subject: "Polity",
      pages: 120,
      size: "3.8 MB",
      lastUpdated: "January 28, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQp8ttkGP5GLaXzNRXrRCJOVinCo0jNf-5e5A&s",
      downloadLink: "/downloads/nagaland-polity-notes.pdf",
      premium: true,
      popular: false,
    },
    {
      id: 3,
      title: "Economic Development of Nagaland",
      description:
        "Comprehensive analysis of Nagaland's economic evolution, challenges, opportunities, and development indicators.",
      type: "notes",
      format: "PDF",
      subject: "Economy",
      pages: 98,
      size: "3.1 MB",
      lastUpdated: "March 5, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJeyb7IQKQvRsaIpkYRwICjic2LCwmdRPAnw&s",
      downloadLink: "/downloads/nagaland-economy-notes.pdf",
      premium: true,
      popular: false,
    },
    {
      id: 4,
      title: "Geography of Nagaland - Physical & Human",
      description:
        "Detailed notes on Nagaland's physiography, climate, natural resources, demographics, and settlements.",
      type: "notes",
      format: "PDF",
      subject: "Geography",
      pages: 112,
      size: "5.6 MB",
      lastUpdated: "February 20, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRhby8223fQUGwLRegqulLf8g2LJnfrSpToyQ&s",
      downloadLink: "/downloads/nagaland-geography-notes.pdf",
      premium: true,
      popular: true,
    },
    {
      id: 5,
      title: "NPSC Previous Years' Question Papers (2015-2024)",
      description:
        "Compilation of last 10 years' question papers for NPSC Prelims and Mains examinations with answer keys.",
      type: "question-papers",
      format: "PDF",
      subject: "General",
      pages: 250,
      size: "12.5 MB",
      lastUpdated: "January 10, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJF4d_Xl2IzqPeOST9UtrSMIKcYtM27H_mwA&s",
      downloadLink: "/downloads/npsc-previous-papers.pdf",
      premium: false,
      popular: true,
    },
    {
      id: 6,
      title: "Nagaland Current Affairs Compendium (2024-2025)",
      description:
        "Monthly compilation of Nagaland-specific current affairs with analysis and NPSC perspective.",
      type: "current-affairs",
      format: "PDF",
      subject: "Current Affairs",
      pages: 75,
      size: "2.8 MB",
      lastUpdated: "March 10, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTVTQleUuLeGoLx0m_nD4zmT1vdUUvmRAvNQ&s",
      downloadLink: "/downloads/nagaland-current-affairs.pdf",
      premium: true,
      popular: true,
    },
    {
      id: 7,
      title: "Nagaland Art, Culture & Heritage",
      description:
        "Comprehensive material on Naga tribes, festivals, traditions, arts, and cultural heritage with NPSC focus.",
      type: "notes",
      format: "PDF",
      subject: "Culture",
      pages: 130,
      size: "8.2 MB",
      lastUpdated: "February 5, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpPJYVXDZ5tMcxOL1mYAMXLtBzakWdrDKpcw&s",
      downloadLink: "/downloads/nagaland-culture-notes.pdf",
      premium: true,
      popular: false,
    },
    {
      id: 8,
      title: "Environment & Biodiversity of Nagaland",
      description:
        "Detailed study of Nagaland's ecosystem, biodiversity, conservation challenges, and environmental policies.",
      type: "notes",
      format: "PDF",
      subject: "Environment",
      pages: 86,
      size: "4.5 MB",
      lastUpdated: "January 15, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvpTR_bHBUSI4RzUhQalgxYdtqvD00d81f0w&s",
      downloadLink: "/downloads/nagaland-environment-notes.pdf",
      premium: true,
      popular: false,
    },
    {
      id: 9,
      title: "NPSC Prelims Mock Test Series (Set of 10)",
      description:
        "Practice tests in NPSC Prelims pattern with detailed explanations for each question.",
      type: "practice-tests",
      format: "PDF",
      subject: "General",
      pages: 200,
      size: "5.8 MB",
      lastUpdated: "March 1, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlfCDrMLC1dmpG9-rVNWvkqCIhupqzXenVVA&s",
      downloadLink: "/downloads/npsc-prelims-tests.pdf",
      premium: true,
      popular: true,
    },
    {
      id: 10,
      title: "NPSC Mains Answer Writing Guide",
      description:
        "Comprehensive guide on effective answer writing for NPSC Mains with examples and templates.",
      type: "guides",
      format: "PDF",
      subject: "General",
      pages: 65,
      size: "2.4 MB",
      lastUpdated: "February 10, 2025",
      thumbnail:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwMaosGwwuSIryd5z7ypRbO6dk85bZF7VC1w&s",
      downloadLink: "/downloads/npsc-answer-writing.pdf",
      premium: false,
      popular: true,
    },
    {
      id: 11,
      title: "Nagaland Government Schemes & Initiatives",
      description:
        "Detailed compilation of current government schemes, initiatives, and programs in Nagaland.",
      type: "notes",
      format: "PDF",
      subject: "Governance",
      pages: 70,
      size: "3.2 MB",
      lastUpdated: "March 5, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX8cR061QGlbIRLCc3Pc2DARYzpuXjLQpQ1w&s",
      downloadLink: "/downloads/nagaland-schemes.pdf",
      premium: true,
      popular: false,
    },
    {
      id: 12,
      title: "Nagaland Peace Process: Historical Evolution",
      description:
        "Comprehensive analysis of Nagaland's peace process, agreements, and political developments.",
      type: "notes",
      format: "PDF",
      subject: "Political Science",
      pages: 88,
      size: "3.6 MB",
      lastUpdated: "January 25, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQfpbGbQxjl4lpbJuvVUw582yq5X2Gkeu_iw&s",
      downloadLink: "/downloads/nagaland-peace-process.pdf",
      premium: true,
      popular: false,
    },
  ];

  // Mock data for video lectures
  const videoLectures = [
    {
      id: 1,
      title: "Understanding Article 371A and Nagaland's Special Status",
      description:
        "Detailed lecture on the constitutional provisions specific to Nagaland and their implications.",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "1h 45m",
      subject: "Polity",
      lastUpdated: "February 5, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSeZjet8U-MjMfS3QFCm61wkNMBoHSHQGT4w&s",
      videoLink: "/videos/article-371a.mp4",
      premium: true,
      popular: true,
    },
    {
      id: 2,
      title: "Evolution of Naga Society: Pre-Colonial to Present",
      description:
        "Comprehensive lecture on the social transformation of Naga communities over time.",
      instructor: "Dr. Imtisunep Longchar",
      duration: "2h 10m",
      subject: "History",
      lastUpdated: "January 20, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCipd36stevKe13vGvw2PtBs9EpJ5wMOz2-g&s",
      videoLink: "/videos/naga-society.mp4",
      premium: true,
      popular: false,
    },
    {
      id: 3,
      title: "Economic Challenges and Opportunities in Nagaland",
      description:
        "Analysis of Nagaland's economic landscape, challenges, and potential growth areas.",
      instructor: "Dr. Rosemary Dzüvichü",
      duration: "1h 50m",
      subject: "Economy",
      lastUpdated: "March 1, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSreLYttEQjE-RDMwPTP6sN8ar-ynmNtBcOyA&s",
      videoLink: "/videos/economic-challenges.mp4",
      premium: true,
      popular: true,
    },
    {
      id: 4,
      title: "Biodiversity Hotspots of Nagaland",
      description:
        "Exploration of Nagaland's rich biodiversity and conservation initiatives.",
      instructor: "Dr. Bendangsenla Jamir",
      duration: "1h 30m",
      subject: "Environment",
      lastUpdated: "February 15, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMFEGCiLMKaj7Xl33Qh1wcb-kCfWlMvjX0QA&s",
      videoLink: "/videos/biodiversity.mp4",
      premium: true,
      popular: false,
    },
    {
      id: 5,
      title: "Naga Tribes: Cultural Distinctions and Commonalities",
      description:
        "Detailed overview of major Naga tribes, their cultural practices, and shared heritage.",
      instructor: "Prof. Ketholenuo Mer",
      duration: "2h 25m",
      subject: "Culture",
      lastUpdated: "January 10, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTB9fMmy7vIesQdo0Yb0hPqLdtqE5ZoFjcP2w&s",
      videoLink: "/videos/naga-tribes.mp4",
      premium: true,
      popular: true,
    },
    {
      id: 6,
      title: "NPSC Prelims Strategy: Approaching MCQs Effectively",
      description:
        "Strategic guidance on tackling multiple-choice questions in NPSC Prelims.",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "1h 15m",
      subject: "Exam Strategy",
      lastUpdated: "March 10, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjhFAcyo1cqDuXPIulGyRkDZpdEpc0OmVNOA&s",
      videoLink: "/videos/prelims-strategy.mp4",
      premium: false,
      popular: true,
    },
    {
      id: 7,
      title: "Governance Structures in Nagaland: Modern & Traditional",
      description:
        "Analysis of the interaction between modern governance systems and traditional institutions in Nagaland.",
      instructor: "Dr. Imtisunep Longchar",
      duration: "2h 05m",
      subject: "Governance",
      lastUpdated: "February 20, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_vPNknhTLCRu-DGslZWFR1oeyBLULxd7dAA&s",
      videoLink: "/videos/governance.mp4",
      premium: true,
      popular: false,
    },
    {
      id: 8,
      title: "NPSC Mains Answer Writing: Structure and Presentation",
      description:
        "Techniques for effective answer writing in NPSC Mains examination.",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "1h 40m",
      subject: "Exam Strategy",
      lastUpdated: "January 25, 2025",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZfvq_5EitlYBuz18qclAnMh7wwDfQbX7QdA&s",
      videoLink: "/videos/mains-writing.mp4",
      premium: false,
      popular: true,
    },
  ];

  // Mock data for tools
  const tools = [
    {
      id: 1,
      title: "NPSC Exam Calendar 2025",
      description:
        "Interactive calendar with all important NPSC exam dates, notification schedules, and preparation milestones.",
      type: "calendar",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT47CO7as6fQI_3Lp2FL7apYPXI_Obc3BbMTg&s",
      link: "/tools/exam-calendar",
      premium: false,
      popular: true,
    },
    {
      id: 2,
      title: "NPSC Syllabus Navigator",
      description:
        "Interactive tool to explore and track your progress through the complete NPSC syllabus.",
      type: "syllabus-tool",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5BmbilWSSlgSwa-pBbf9BKU0NbgG3im103A&s",
      link: "/tools/syllabus-navigator",
      premium: false,
      popular: true,
    },
    {
      id: 3,
      title: "NPSC Prelims Score Calculator",
      description:
        "Calculate your potential Prelims score based on your answers and official answer key.",
      type: "calculator",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_SaJ7rk8kUXMA0yzLkRo65qmNGWbkFM-eiA&s",
      link: "/tools/score-calculator",
      premium: false,
      popular: false,
    },
    {
      id: 4,
      title: "Nagaland Districts Interactive Map",
      description:
        "Interactive map of Nagaland's districts with key information about each region.",
      type: "map",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTtxPoJK0dXgacIxqWF_4bct8oEsjo1b9b7w&s",
      link: "/tools/districts-map",
      premium: true,
      popular: true,
    },
    {
      id: 5,
      title: "NPSC Study Planner",
      description:
        "Personalized study planning tool to create and track your NPSC preparation schedule.",
      type: "planner",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSPwt-TPAAHpkEVnCPMXSfrespcVwLRj_jkw&s",
      link: "/tools/study-planner",
      premium: true,
      popular: true,
    },
    {
      id: 6,
      title: "Current Affairs Tracker",
      description:
        "Tool to track important current affairs relevant to NPSC examination.",
      type: "tracker",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjoia918s_FnWLxU_Bs3bxWPYy2FdV-Df41A&s",
      link: "/tools/current-affairs-tracker",
      premium: true,
      popular: false,
    },
  ];

  // Mock data for flashcards
  const flashcards = [
    {
      id: 1,
      title: "Nagaland History Key Dates & Events",
      description:
        "Essential dates and events from Nagaland's history for quick revision.",
      cards: 85,
      subject: "History",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBYIWA2Dgm2AU6E2hr_EPd-m6D5fp4YPr1EQ&s",
      link: "/flashcards/history-dates",
      premium: false,
      popular: true,
    },
    {
      id: 2,
      title: "Article 371A Provisions Flashcards",
      description:
        "Detailed breakdown of Article 371A provisions and implications.",
      cards: 40,
      subject: "Polity",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuknFu7144u4zMreBW0ZNUIDehN9sNPmojsQ&s",
      link: "/flashcards/article-371a",
      premium: true,
      popular: true,
    },
    {
      id: 3,
      title: "Naga Tribes & Their Characteristics",
      description:
        "Flashcards featuring key information about major Naga tribes.",
      cards: 60,
      subject: "Culture",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSIDbfO8DIMucv09OSW6jK4cuwBdfWl8i4dw&s",
      link: "/flashcards/naga-tribes",
      premium: true,
      popular: false,
    },
    {
      id: 4,
      title: "Nagaland Geography Quick Facts",
      description:
        "Essential geographical information about Nagaland for rapid revision.",
      cards: 70,
      subject: "Geography",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUsY6ali3kzZzuehGTqDYa8FZAI34oVZdUjQ&s",
      link: "/flashcards/geography-facts",
      premium: false,
      popular: true,
    },
    {
      id: 5,
      title: "Economic Indicators of Nagaland",
      description:
        "Key economic statistics and indicators related to Nagaland's development.",
      cards: 45,
      subject: "Economy",
      thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYeke0Fkm7sf8NgP9YBbWB1CS7HpvUAoaBEg&s",
      link: "/flashcards/economic-indicators",
      premium: true,
      popular: false,
    },
  ];

  // Filter study materials based on filter settings
  const getFilteredResources = () => {
    let filteredItems = [];

    // Select the right resource type based on tab
    if (currentTab === "study-materials") {
      filteredItems = [...studyMaterials];
    } else if (currentTab === "video-lectures") {
      filteredItems = [...videoLectures];
    } else if (currentTab === "tools") {
      filteredItems = [...tools];
    } else if (currentTab === "flashcards") {
      filteredItems = [...flashcards];
    }

    // Apply resource type filter (only for study materials)
    if (currentTab === "study-materials" && resourceType !== "all") {
      filteredItems = filteredItems.filter(
        (item) => item.type === resourceType
      );
    }

    // Apply subject filter (applicable to study materials and video lectures)
    if (
      (currentTab === "study-materials" ||
        currentTab === "video-lectures" ||
        currentTab === "flashcards") &&
      subjectFilter !== "all"
    ) {
      filteredItems = filteredItems.filter(
        (item) => item.subject === subjectFilter
      );
    }

    // Apply search filter (applicable to all)
    if (searchQuery) {
      filteredItems = filteredItems.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return filteredItems;
  };

  // Get filtered resources
  const filteredResources = getFilteredResources();

  // Get unique subjects for filter dropdown based on current tab
  const getSubjects = () => {
    let items = [];

    if (currentTab === "study-materials") {
      items = studyMaterials;
    } else if (currentTab === "video-lectures") {
      items = videoLectures;
    } else if (currentTab === "flashcards") {
      items = flashcards;
    }

    return [...new Set(items.map((item) => item.subject))].sort();
  };

  const subjects = getSubjects();

  // Reset filters when changing tabs
  const handleTabChange = (tab) => {
    setCurrentTab(tab);
    setResourceType("all");
    setSubjectFilter("all");
    setSearchQuery("");
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
          <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] bg-cover bg-center mix-blend-overlay"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              NPSC Study Resources
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl mb-8 text-gray-200"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Access comprehensive study materials, video lectures, interactive
              tools, and more to enhance your NPSC preparation. Our resources
              are tailored specifically for Nagaland PSC aspirants.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a
                href="#resources"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
              >
                Browse Resources
              </a>
              <Link
                to="/premium"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                Get Premium Access
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Resources Overview Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Comprehensive Resources for NPSC Preparation
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Everything you need to excel in your NPSC journey
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 text-center cursor-pointer"
              onClick={() => handleTabChange("study-materials")}
            >
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 mx-auto mb-4">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Study Materials
              </h3>
              <p className="text-gray-600 mb-4">
                Comprehensive notes, question papers, and practice tests
                specifically designed for NPSC preparation.
              </p>
              <p className="text-sm text-gray-600 font-medium">
                {studyMaterials.length} resources available
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 text-center cursor-pointer"
              onClick={() => handleTabChange("video-lectures")}
            >
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 mx-auto mb-4">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Video Lectures
              </h3>
              <p className="text-gray-600 mb-4">
                Expert video lectures on key topics by experienced faculty
                members with NPSC expertise.
              </p>
              <p className="text-sm text-gray-600 font-medium">
                {videoLectures.length} videos available
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 text-center cursor-pointer"
              onClick={() => handleTabChange("tools")}
            >
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 mx-auto mb-4">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Interactive Tools
              </h3>
              <p className="text-gray-600 mb-4">
                Practical tools to enhance your preparation, including planners,
                calculators, and interactive maps.
              </p>
              <p className="text-sm text-gray-600 font-medium">
                {tools.length} tools available
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 text-center cursor-pointer"
              onClick={() => handleTabChange("flashcards")}
            >
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 mx-auto mb-4">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Flashcards
              </h3>
              <p className="text-gray-600 mb-4">
                Quick revision flashcards for important dates, facts, and
                concepts relevant to NPSC examination.
              </p>
              <p className="text-sm text-gray-600 font-medium">
                {flashcards.length} flashcard sets available
              </p>
            </motion.div>
          </div>

          <div className="mt-16 bg-gray-50 p-8 rounded-xl">
            <div className="flex flex-col md:flex-row items-start md:items-center">
              <div className="mb-6 md:mb-0 md:mr-8 flex-shrink-0">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-600">
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Premium Access Benefits
                </h3>
                <p className="text-gray-700 mb-4">
                  Unlock our complete library of premium resources with a
                  subscription and take your NPSC preparation to the next level.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Exclusive study materials
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Full-length video lectures
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Advanced interactive tools
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">Regular updates</span>
                  </div>
                </div>
                <div className="mt-6">
                  <Link
                    to="/premium"
                    className="inline-flex items-center justify-center px-5 py-2 border border-transparent text-base font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 transition-colors duration-300"
                  >
                    View Premium Plans
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section id="resources" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Browse Resources
            </h2>

            {/* Resource Tabs */}
            <div className="border-b border-gray-200 mb-8">
              <div className="flex overflow-x-auto">
                <button
                  className={`py-4 px-6 text-md font-medium whitespace-nowrap ${
                    currentTab === "study-materials"
                      ? "border-b-2 border-gray-600 text-gray-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                  onClick={() => handleTabChange("study-materials")}
                >
                  Study Materials
                </button>
                <button
                  className={`py-4 px-6 text-md font-medium whitespace-nowrap ${
                    currentTab === "video-lectures"
                      ? "border-b-2 border-gray-600 text-gray-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                  onClick={() => handleTabChange("video-lectures")}
                >
                  Video Lectures
                </button>
                <button
                  className={`py-4 px-6 text-md font-medium whitespace-nowrap ${
                    currentTab === "tools"
                      ? "border-b-2 border-gray-600 text-gray-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                  onClick={() => handleTabChange("tools")}
                >
                  Interactive Tools
                </button>
                <button
                  className={`py-4 px-6 text-md font-medium whitespace-nowrap ${
                    currentTab === "flashcards"
                      ? "border-b-2 border-gray-600 text-gray-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                  onClick={() => handleTabChange("flashcards")}
                >
                  Flashcards
                </button>
              </div>
            </div>

            {/* Filters */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
              <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 mb-4 md:mb-0">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                    />
                  </svg>
                  {showFilters ? "Hide Filters" : "Show Filters"}
                </button>
                <div className="relative">
                  <input
                    type="text"
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-gray-500 focus:border-gray-500"
                    placeholder="Search resources..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-5 w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-sm text-gray-500 mr-2">
                  {filteredResources.length} resources found
                </span>
              </div>
            </div>

            {/* Expanded Filters */}
            {showFilters && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-lg p-4 mb-6 shadow-sm"
              >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* Resource Type Filter (only for study materials) */}
                  {currentTab === "study-materials" && (
                    <div>
                      <label
                        htmlFor="resource-type"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Resource Type
                      </label>
                      <select
                        id="resource-type"
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500"
                        value={resourceType}
                        onChange={(e) => setResourceType(e.target.value)}
                      >
                        <option value="all">All Types</option>
                        <option value="notes">Notes</option>
                        <option value="question-papers">Question Papers</option>
                        <option value="practice-tests">Practice Tests</option>
                        <option value="guides">Guides</option>
                        <option value="current-affairs">Current Affairs</option>
                      </select>
                    </div>
                  )}

                  {/* Subject Filter (for study materials, video lectures, and flashcards) */}
                  {(currentTab === "study-materials" ||
                    currentTab === "video-lectures" ||
                    currentTab === "flashcards") && (
                    <div>
                      <label
                        htmlFor="subject-filter"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Subject
                      </label>
                      <select
                        id="subject-filter"
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500"
                        value={subjectFilter}
                        onChange={(e) => setSubjectFilter(e.target.value)}
                      >
                        <option value="all">All Subjects</option>
                        {subjects.map((subject) => (
                          <option key={subject} value={subject}>
                            {subject}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Access Type Filter */}
                  <div>
                    <fieldset className="mt-6">
                      <legend className="text-sm font-medium text-gray-700">
                        Access Type
                      </legend>
                      <div className="mt-2 space-y-4">
                        <div className="flex items-center">
                          <input
                            id="access-all"
                            name="access-type"
                            type="radio"
                            defaultChecked
                            className="h-4 w-4 border-gray-300 text-gray-600 focus:ring-gray-500"
                          />
                          <label
                            htmlFor="access-all"
                            className="ml-3 block text-sm text-gray-700"
                          >
                            All Resources
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            id="access-free"
                            name="access-type"
                            type="radio"
                            className="h-4 w-4 border-gray-300 text-gray-600 focus:ring-gray-500"
                          />
                          <label
                            htmlFor="access-free"
                            className="ml-3 block text-sm text-gray-700"
                          >
                            Free Only
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            id="access-premium"
                            name="access-type"
                            type="radio"
                            className="h-4 w-4 border-gray-300 text-gray-600 focus:ring-gray-500"
                          />
                          <label
                            htmlFor="access-premium"
                            className="ml-3 block text-sm text-gray-700"
                          >
                            Premium Only
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => {
                      setResourceType("all");
                      setSubjectFilter("all");
                      setSearchQuery("");
                    }}
                    className="text-sm text-gray-600 hover:text-gray-800 font-medium"
                  >
                    Reset All Filters
                  </button>
                </div>
              </motion.div>
            )}

            {/* Study Materials Tab Content */}
            {currentTab === "study-materials" &&
              filteredResources.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredResources.map((material) => (
                    <motion.div
                      key={material.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all duration-300"
                    >
                      <div className="relative h-48">
                        <img
                          src={
                            material.thumbnail || "/images/default-resource.jpg"
                          }
                          alt={material.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute top-0 right-0 mt-2 mr-2 flex space-x-2">
                          {material.premium ? (
                            <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Premium
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Free
                            </span>
                          )}
                          {material.popular && (
                            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Popular
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="p-5">
                        <div className="flex justify-between items-start mb-2">
                          <h3 className="text-lg font-bold text-gray-900 line-clamp-2">
                            {material.title}
                          </h3>
                          <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded flex items-center">
                            <span className="w-2 h-2 bg-gray-500 rounded-full mr-1"></span>
                            {material.format}
                          </span>
                        </div>
                        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                          {material.description}
                        </p>
                        <div className="flex flex-wrap gap-2 mb-4">
                          <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                            {material.subject}
                          </span>
                          <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                            {material.pages} pages
                          </span>
                          <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                            {material.size}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-xs text-gray-500">
                            Updated {material.lastUpdated}
                          </span>
                          {material.premium ? (
                            <Link
                              to="/premium"
                              className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                            >
                              <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                />
                              </svg>
                              Unlock
                            </Link>
                          ) : (
                            <a
                              href={material.downloadLink}
                              className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                              download
                            >
                              <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                />
                              </svg>
                              Download
                            </a>
                          )}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}

            {/* Video Lectures Tab Content */}
            {currentTab === "video-lectures" &&
              filteredResources.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredResources.map((video) => (
                    <motion.div
                      key={video.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all duration-300"
                    >
                      <div className="relative h-48">
                        <img
                          src={video.thumbnail || "/images/default-video.jpg"}
                          alt={video.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                          <div className="w-14 h-14 bg-white bg-opacity-80 rounded-full flex items-center justify-center">
                            <svg
                              className="w-7 h-7 text-gray-600"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
                            </svg>
                          </div>
                        </div>
                        <div className="absolute top-0 right-0 mt-2 mr-2 flex space-x-2">
                          {video.premium ? (
                            <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Premium
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Free
                            </span>
                          )}
                          {video.popular && (
                            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                              Popular
                            </span>
                          )}
                        </div>
                        <div className="absolute bottom-0 left-0 mb-2 ml-2">
                          <span className="bg-black bg-opacity-70 text-white text-xs font-medium px-2.5 py-0.5 rounded">
                            {video.duration}
                          </span>
                        </div>
                      </div>
                      <div className="p-5">
                        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                          {video.title}
                        </h3>
                        <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                          {video.description}
                        </p>
                        <div className="flex items-center mb-3">
                          <svg
                            className="w-4 h-4 mr-1 text-gray-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                          <span className="text-gray-600 text-sm">
                            {video.instructor}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-2 mb-4">
                          <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                            {video.subject}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-xs text-gray-500">
                            Updated {video.lastUpdated}
                          </span>
                          {video.premium ? (
                            <Link
                              to="/premium"
                              className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                            >
                              <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                />
                              </svg>
                              Unlock
                            </Link>
                          ) : (
                            <Link
                              to={video.videoLink}
                              className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                            >
                              <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                              Watch
                            </Link>
                          )}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}

            {/* Tools Tab Content */}
            {currentTab === "tools" && filteredResources.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredResources.map((tool) => (
                  <motion.div
                    key={tool.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all duration-300"
                  >
                    <div className="relative h-48">
                      <img
                        src={tool.thumbnail || "/images/default-tool.jpg"}
                        alt={tool.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-0 right-0 mt-2 mr-2 flex space-x-2">
                        {tool.premium ? (
                          <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Premium
                          </span>
                        ) : (
                          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Free
                          </span>
                        )}
                        {tool.popular && (
                          <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Popular
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="p-5">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">
                        {tool.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-5 line-clamp-3">
                        {tool.description}
                      </p>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-500">
                          Tool Type:{" "}
                          <span className="font-medium">
                            {tool.type
                              .replace("-", " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase())}
                          </span>
                        </span>
                        {tool.premium ? (
                          <Link
                            to="/premium"
                            className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                              />
                            </svg>
                            Unlock
                          </Link>
                        ) : (
                          <Link
                            to={tool.link}
                            className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                              />
                            </svg>
                            Open Tool
                          </Link>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}

            {/* Flashcards Tab Content */}
            {currentTab === "flashcards" && filteredResources.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredResources.map((flashcard) => (
                  <motion.div
                    key={flashcard.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all duration-300"
                  >
                    <div className="relative h-40">
                      <img
                        src={
                          flashcard.thumbnail || "/images/default-flashcard.jpg"
                        }
                        alt={flashcard.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-0 right-0 mt-2 mr-2 flex space-x-2">
                        {flashcard.premium ? (
                          <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Premium
                          </span>
                        ) : (
                          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Free
                          </span>
                        )}
                        {flashcard.popular && (
                          <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Popular
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="p-5">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">
                        {flashcard.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                        {flashcard.description}
                      </p>
                      <div className="flex flex-wrap gap-2 mb-4">
                        <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                          {flashcard.subject}
                        </span>
                        <span className="bg-gray-50 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded">
                          {flashcard.cards} cards
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center">
                          <svg
                            className="w-4 h-4 text-gray-500 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                            />
                          </svg>
                          <span className="text-xs text-gray-600">
                            Flashcards
                          </span>
                        </div>
                        {flashcard.premium ? (
                          <Link
                            to="/premium"
                            className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                              />
                            </svg>
                            Unlock
                          </Link>
                        ) : (
                          <Link
                            to={flashcard.link}
                            className="inline-flex items-center text-gray-600 hover:text-gray-800 font-medium text-sm"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                              />
                            </svg>
                            Open Flashcards
                          </Link>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}

            {/* No Results */}
            {filteredResources.length === 0 && (
              <div className="text-center py-16">
                <svg
                  className="w-16 h-16 text-gray-300 mx-auto mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h3 className="text-lg font-medium text-gray-900 mb-1">
                  No resources found
                </h3>
                <p className="text-gray-600 mb-4">
                  Try adjusting your search or filter criteria
                </p>
                <button
                  onClick={() => {
                    setResourceType("all");
                    setSubjectFilter("all");
                    setSearchQuery("");
                  }}
                  className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700"
                >
                  Reset Filters
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Popular Collections Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <motion.h2
              className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Popular Resource Collections
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Curated collections of resources for specific topics and exam
              stages
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="relative bg-gradient-to-r from-blue-600 to-gray-700 rounded-lg overflow-hidden"
            >
              <div className="absolute inset-0 opacity-20">
                <img
                  src="/images/collections/prelims.jpg"
                  alt="Prelims Collection"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 relative z-10 text-white">
                <h3 className="text-2xl font-bold mb-3">Prelims Mastery Kit</h3>
                <p className="mb-4 text-gray-100">
                  Everything you need to ace the NPSC Prelims examination, from
                  practice tests to strategic guidance.
                </p>
                <div className="flex items-center space-x-4 mb-6">
                  <div className="text-center">
                    <span className="block text-2xl font-bold">25+</span>
                    <span className="text-xs text-gray-200">Resources</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">10+</span>
                    <span className="text-xs text-gray-200">
                      Practice Tests
                    </span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">5+</span>
                    <span className="text-xs text-gray-200">
                      Video Lectures
                    </span>
                  </div>
                </div>
                <Link
                  to="/collections/prelims"
                  className="inline-flex items-center py-2 px-4 bg-white text-gray-700 rounded-md font-medium hover:bg-gray-50 transition-colors duration-300"
                >
                  <span>View Collection</span>
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="relative bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg overflow-hidden"
            >
              <div className="absolute inset-0 opacity-20">
                <img
                  src="/images/collections/mains.jpg"
                  alt="Mains Collection"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 relative z-10 text-white">
                <h3 className="text-2xl font-bold mb-3">
                  Mains Answer Writing Kit
                </h3>
                <p className="mb-4 text-purple-100">
                  Comprehensive resources to help you master answer writing
                  skills for NPSC Mains examination.
                </p>
                <div className="flex items-center space-x-4 mb-6">
                  <div className="text-center">
                    <span className="block text-2xl font-bold">20+</span>
                    <span className="text-xs text-purple-200">Resources</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">15+</span>
                    <span className="text-xs text-purple-200">
                      Answer Templates
                    </span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">8+</span>
                    <span className="text-xs text-purple-200">
                      Video Tutorials
                    </span>
                  </div>
                </div>
                <Link
                  to="/collections/mains"
                  className="inline-flex items-center py-2 px-4 bg-white text-purple-700 rounded-md font-medium hover:bg-purple-50 transition-colors duration-300"
                >
                  <span>View Collection</span>
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative bg-gradient-to-r from-green-600 to-teal-600 rounded-lg overflow-hidden"
            >
              <div className="absolute inset-0 opacity-20">
                <img
                  src="/images/collections/nagaland.jpg"
                  alt="Nagaland Collection"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 relative z-10 text-white">
                <h3 className="text-2xl font-bold mb-3">
                  Complete Nagaland Focus
                </h3>
                <p className="mb-4 text-green-100">
                  Specialized resources covering all aspects of Nagaland -
                  history, culture, governance, economy, and current affairs.
                </p>
                <div className="flex items-center space-x-4 mb-6">
                  <div className="text-center">
                    <span className="block text-2xl font-bold">30+</span>
                    <span className="text-xs text-green-200">Resources</span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">12+</span>
                    <span className="text-xs text-green-200">
                      Subject Areas
                    </span>
                  </div>
                  <div className="text-center">
                    <span className="block text-2xl font-bold">10+</span>
                    <span className="text-xs text-green-200">
                      Video Lectures
                    </span>
                  </div>
                </div>
                <Link
                  to="/collections/nagaland"
                  className="inline-flex items-center py-2 px-4 bg-white text-green-700 rounded-md font-medium hover:bg-green-50 transition-colors duration-300"
                >
                  <span>View Collection</span>
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <motion.h2
              className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Success Stories
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Hear from successful candidates who used our resources for their
              NPSC preparation
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-gray-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "The study materials provided by NPSC Academy were instrumental
                in my success. The comprehensive notes on Nagaland history and
                current affairs were exactly what I needed, covering all the
                important topics that appeared in the exam."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonials/testimonial-1.jpg"
                    alt="Theja Kezo"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Theja Kezo
                  </h3>
                  <p className="text-gray-600 font-medium">
                    NPSC 2023 Selected
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-gray-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "The interactive tools, especially the Syllabus Navigator and
                NPSC Study Planner, helped me organize my preparation
                effectively. I could track my progress and focus on areas that
                needed more attention. The flashcards were perfect for
                last-minute revision."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonials/testimonial-2.jpg"
                    alt="Alemla Imsong"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Alemla Imsong
                  </h3>
                  <p className="text-gray-600 font-medium">
                    NPSC 2023 Selected
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-gray-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "The video lectures by Prof. Kezhokhoto Savi on Article 371A
                were exceptional. The content was so well explained that it
                cleared all my doubts, and I could answer related questions with
                confidence in both Prelims and Mains."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonials/testimonial-3.jpg"
                    alt="Khrienuo Metha"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Khrienuo Metha
                  </h3>
                  <p className="text-gray-600 font-medium">
                    NPSC 2022 Selected
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-gray-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Unlock Premium Resources</h2>
          <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
            Get unlimited access to our complete library of premium study
            materials, video lectures, interactive tools, and more.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link
              to="/premium"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
            >
              Get Premium Access
            </Link>
            <Link
              to="/free-resources"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
            >
              Browse Free Resources
            </Link>
          </div>
        </div>
      </section>

      {/* Request Resources */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
            <div className="md:flex md:items-center md:justify-between">
              <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Can't Find What You're Looking For?
                </h2>
                <p className="text-gray-600 mb-6">
                  If you need specific resources that aren't currently available
                  in our library, let us know. We're constantly adding new
                  materials based on student requests.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Custom study notes
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Specific topic videos
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Practice test sets
                    </span>
                  </div>
                  <div className="flex items-start">
                    <svg
                      className="h-5 w-5 text-gray-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-2 text-gray-600">
                      Specialized tools
                    </span>
                  </div>
                </div>
              </div>
              <div className="md:w-1/3">
                <Link
                  to="/request-resource"
                  className="block w-full py-3 px-4 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-md text-center shadow-sm transition-colors duration-300"
                >
                  Request a Resource
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesPage;
